import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    class: "btn btn-attention",
    type: "button",
    disabled: _ctx.isSpinning || _ctx.disabled,
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)))
  }, [
    _createElementVNode("i", {
      class: _normalizeClass((_ctx.isSpinning ? 'visible fa-spin' : 'invisible') + ' fas faw fa-spinner'),
      role: "status",
      "aria-hidden": "true"
    }, null, 2),
    _createTextVNode(" " + _toDisplayString(_ctx.title) + " ", 1),
    _cache[1] || (_cache[1] = _createElementVNode("i", {
      class: "invisible fas faw fa-spinner",
      role: "status",
      "aria-hidden": "true"
    }, null, -1))
  ], 8, _hoisted_1))
}